var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.99 7.80863V7.81V16.19C21.99 17.9106 21.4791 19.2238 20.5964 20.1064C19.7138 20.9891 18.4006 21.5 16.68 21.5H8.31C6.58945 21.5 5.27634 20.9891 4.39377 20.1054C3.51114 19.2217 3 17.9059 3 16.18V7.81C3 6.08944 3.51093 4.77618 4.39355 3.89355C5.27618 3.01093 6.58944 2.5 8.31 2.5H16.69C18.4107 2.5 19.7237 3.01097 20.605 3.89333C21.4861 4.77559 21.9947 6.08838 21.99 7.80863ZM15.8435 13.2484L15.8452 13.2463L18.154 10.2678C18.1542 10.2676 18.1543 10.2674 18.1545 10.2672C18.5821 9.71925 18.4629 8.94359 17.9366 8.51302L17.9353 8.51194C17.394 8.07218 16.5926 8.175 16.1734 8.72556L14.0129 11.5126L12.3792 10.2271L12.3784 10.2265C11.9046 9.85511 11.3011 9.68686 10.7067 9.76403C10.1019 9.84123 9.57489 10.1515 9.20647 10.6216L9.20646 10.6215L9.20388 10.6249L6.82388 13.7149L6.82387 13.7149L6.82145 13.7181C6.40914 14.2623 6.50289 15.0449 7.05455 15.4659C7.28538 15.646 7.55386 15.73 7.82 15.73C8.19114 15.73 8.55646 15.5614 8.80244 15.2498L8.80247 15.2498L8.80612 15.2451L11.0377 12.3478L12.6708 13.6329L12.6716 13.6335C13.1439 14.0038 13.7354 14.1722 14.3381 14.0966C14.9486 14.0302 15.4765 13.7167 15.8435 13.2484Z",
    fill: "#0063F6",
    stroke: "#0063F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityActive);
export default __webpack_public_path__ + "static/media/activity-active.51663f5c1c8d1871e45f9ec26520fa2c.svg";
export { ForwardRef as ReactComponent };